<template>
  <div data-wizard-id="main-page">
    <MainMap></MainMap>
    <!--<WizardContainer></WizardContainer>-->
  </div>
</template>

<script>
import MainMap from '@/components/MainMap.vue';
import { mapActions, mapState } from 'vuex';
import naja from 'naja';
import MeService from '@/services/MeService';

//import WizardContainer from '@/components/wizard/WizardContainer.vue';

export default {
  props: {
    phaseid: {
      type: Number,
      required: true
    },
    controlsright: {
      type: String,
      required: true
    },
    controlsleft: {
      type: String,
      required: true
    },
    accesstoken: {
      type: String,
      required: true
    },
    userid: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      areaId: null
    };
  },
  created() {
    naja.initialize({
      history: false
    });
    this.$store.dispatch('general/setAccessToken', this.accesstoken);
    this.$store.dispatch('general/setUserId', this.userid);

    this.$store.dispatch('general/setPhase', this.phaseid);
    this.$store.dispatch('general/loadPhases');
    this.$store.dispatch('general/loadAreas');
    this.$store.dispatch('general/loadButtons');

    MeService.getMe().then((userData) => {
      this.$store.dispatch('general/setUser', userData);
    });

    let urlParams;
    (window.onpopstate = function () {
      let match,
        pl = /\+/g, // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
          return decodeURIComponent(s.replace(pl, ' '));
        },
        query = window.location.search.substring(1);

      urlParams = {};
      while ((match = search.exec(query)))
        urlParams[decode(match[1])] = decode(match[2]);
    })();

    let currentAreaId = Number(urlParams['areaId']);

    if (currentAreaId) {
      this.areaId = currentAreaId;
      this.$store.dispatch('general/setAreaId', this.areaId);
    }

    this.initiateLayout(this.$route, this.$store);

    // Redirect old URL to new one
    if (this.$route.name === 'baseOld') {
      let obj = {
        ...this.$route.params
      };
      obj['activeLayersOpacity'] = JSON.stringify([]);
      obj['openTexts'] = JSON.stringify([]);
      obj['openSettings'] = JSON.stringify([]);
      obj['openPinLayers'] = JSON.stringify([]);
      obj['openPins'] = JSON.stringify([]);
      this.$router.replace({ name: 'base', params: obj }).catch((err) => {});
    }

    let routeParams = {
      ...this.$route.params
    };

    // Uninitialized phase ID => set current phase ID (passed from BE in HTML init)
    if (routeParams['phase'] == -1) {
      routeParams['phase'] = this.phaseid;
      this.$router
        .replace({ name: 'base', params: routeParams })
        .catch((err) => {});
    }
  },
  components: {
    MainMap
    //WizardContainer
  },
  computed: {
    ...mapActions([
      'general/setPhase',
      'general/setControlsRight',
      'general/setControlsLeft',
      'general/setUserId'
    ]),
    ...mapState(['general'])
  },
  methods: {
    initiateLayout: (route, store) => {
      if (
        route.params.sidebarRight &&
        route.params.sidebarLeft &&
        route.params.phasesTimeline &&
        route.params.layers
      ) {
        store.dispatch('general/setLayoutOption', [
          'sidebarRight',
          JSON.parse(route.params.sidebarRight)
        ]);
        store.dispatch('general/setLayoutOption', [
          'sidebarLeft',
          JSON.parse(route.params.sidebarLeft)
        ]);
        store.dispatch('general/setLayoutOption', [
          'phasesTimeline',
          JSON.parse(route.params.phasesTimeline)
        ]);
        store.dispatch('general/setLayoutOption', [
          'layers',
          JSON.parse(route.params.layers)
        ]);
      }
    }
  },
  watch: {
    $route() {
      const showKatastr = this.general.showCadastralLayer ? 1 : 0;
      const mapButtonSelectedLayerId = this.general.mapButtonSelectedLayerId
        ? this.general.mapButtonSelectedLayerId
        : null;

      let query = {
        ...this.$route.query
      };

      if (
        !query.mapButtonSelectedLayerId ||
        (query.mapButtonSelectedLayerId &&
          query.mapButtonSelectedLayerId != mapButtonSelectedLayerId)
      ) {
        query.mapButtonSelectedLayerId = mapButtonSelectedLayerId;
        this.$router.replace({ name: 'base', query }).catch((err) => {});
      }

      if (!query.katastr || (query.katastr && query.katastr != showKatastr)) {
        query.katastr = showKatastr;
        this.$router.replace({ name: 'base', query }).catch((err) => {});
      }
    },
    'general.mapButtonSelectedLayerId'(newValue) {
      const mapButtonSelectedLayerId = newValue;

      let query = {
        ...this.$route.query
      };

      query.mapButtonSelectedLayerId = mapButtonSelectedLayerId;
      this.$router.replace({ name: 'base', query }).catch((err) => {});
    }
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

.App {
  width: 100vw;
  height: 100vh;
}

.gm-style-iw-a img {
  max-width: 100%;
  max-height: 350px;
}

.btnStyled {
  background: none;
  border: none;
  font-size: 13px;
}

.support {
  color: #84c03f;
}

.edit {
  color: dodgerblue;
}

.delete {
  color: red;
}

textarea {
  resize: none;
}

.pinDetailBox {
  min-width: 200px;
  max-width: 450px;
  white-space: normal;
}

.tooltip {
  display: block !important;
  z-index: 10000;
  /* max-width: 400px; */
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^='top'] {
  margin-bottom: 5px;
}

.tooltip[x-placement^='top'] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^='bottom'] {
  margin-top: 5px;
}

.tooltip[x-placement^='bottom'] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^='right'] {
  margin-left: 5px;
}

.tooltip[x-placement^='right'] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^='left'] {
  margin-right: 5px;
}

.tooltip[x-placement^='left'] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.strikeText {
  text-decoration: line-through;
}
.highlight {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.5);
  z-index: 9999;
  transition: all 0.5s ease;
}
</style>
